import { Component } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { Navigation } from './shared/components/navigation/navigation';
import { GlobalLoaderComponent } from './shared';
import { NotificationComponent } from './shared/components/notification';
import { AppRoutes } from './core/constants/routes.constants';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navigation, GlobalLoaderComponent, NotificationComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  isLoginRoute = false;

  constructor(private readonly router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.isLoginRoute = event.urlAfterRedirects === `/${AppRoutes.LOGIN}`;
      });
  }
}
